import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PatchTaskBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

export function useUpdateTask(taskId: string) {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (input: PatchTaskBody) => {
      const response = await api.patch('/tasks/:taskId', { params: { taskId }, body: input })
      if (!response.success) throw new Error(response.error.message)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tasks'] })
      queryClient.invalidateQueries({ queryKey: ['patient-tasks'] })
      queryClient.invalidateQueries({ queryKey: ['patient-timeline'] })
      // Keep the sidebar "my tasks" badge in sync when a task's status changes
      // (e.g. completion) or it's reassigned away from the current user.
      queryClient.invalidateQueries({ queryKey: ['my-tasks'] })
    },
  })
}
